/**
 * Soll-Endzeit einer Folie gegen die Uhr: „bis 14:27" bzw. wie viele
 * Minuten wir drüber sind. Reine Funktion, damit sie ohne DOM testbar ist.
 */
export function sollStatus(
  soll: string,
  jetzt: Date,
): { text: string; ueberMin: number } | null {
  const m = /^(\d{1,2}):(\d{2})$/.exec(soll.trim());
  if (!m) return null;
  const ziel = new Date(jetzt);
  ziel.setHours(Number(m[1]), Number(m[2]), 0, 0);
  const ueberMin = Math.floor((jetzt.getTime() - ziel.getTime()) / 60000);
  return { text: `${m[1].padStart(2, "0")}:${m[2]}`, ueberMin: Math.max(0, ueberMin) };
}
